/* eslint-disable no-underscore-dangle */
import { Button } from '@coop/components';
import { ShieldIcon } from '@coop/icons';

const ConsentButton = () => {
    const showPopup = () => {
        if (window && window.__cmp) {
            window.__cmp('showScreen');
        }
    };

    return (
        <Button onClick={showPopup} icon={<ShieldIcon />} theme="secondary">
            Inställningar för cookies
        </Button>
    );
};

export default ConsentButton;
